"use client";

import dynamic from "next/dynamic";

/**
 * Lazy-loaded, below-the-fold landing islands.
 *
 * These interactive client components sit below the fold, so we load them via
 * `next/dynamic` with `ssr: false`: their JS neither ships in the initial
 * payload nor hydrates on first paint, which cuts main-thread Script Evaluation
 * (a PageSpeed finding). Each `loading` skeleton reserves height to avoid layout
 * shift, and every section's heading/intro copy stays server-rendered (in
 * page.tsx) — only the interactive widget body defers, so the SEO copy is
 * unaffected. `WhyItWorksStats` is a server component (zero client JS) and is
 * intentionally NOT wrapped here.
 */

function Skeleton({ minHeight }: { minHeight: number }) {
  return (
    <div
      aria-hidden="true"
      className="mx-auto w-full max-w-column animate-pulse rounded-s5-lg bg-s5-border/30"
      style={{ minHeight }}
    />
  );
}

export const GlobalLeakCounterLazy = dynamic(
  () => import("./global-leak-counter").then((m) => m.GlobalLeakCounter),
  { ssr: false, loading: () => <Skeleton minHeight={96} /> },
);

export const InlineQuizPreviewLazy = dynamic(
  () => import("./inline-quiz-preview").then((m) => m.InlineQuizPreview),
  { ssr: false, loading: () => <Skeleton minHeight={340} /> },
);

export const TestimonialRotationLazy = dynamic(
  () => import("./testimonial-rotation").then((m) => m.TestimonialRotation),
  { ssr: false, loading: () => <Skeleton minHeight={300} /> },
);
